import React from 'react';
import { Navigate } from 'react-router-dom';
import { isFeatureAvailable, IOS_APP_DISABLED_FEATURES, NATIVE_APP_DISABLED_FEATURES } from '../config/features';

type DisabledFeatureKey = keyof typeof IOS_APP_DISABLED_FEATURES | keyof typeof NATIVE_APP_DISABLED_FEATURES;

interface PlatformProtectedRouteProps {
  children: React.ReactElement;
  feature?: DisabledFeatureKey;
  redirectTo?: string;
}

/**
 * 플랫폼별로 기능을 보호하는 라우트 컴포넌트
 * 특정 플랫폼(iOS/Android/네이티브)에서 기능이 비활성화되어 있으면 리다이렉트합니다.
 * 
 * @example
 * <Route 
 *   path="/minecraft-education" 
 *   element={
 *     <PlatformProtectedRoute feature="MINECRAFT_EDUCATION" redirectTo="/">
 *       <MinecraftEducationMain />
 *     </PlatformProtectedRoute>
 *   } 
 * />
 */
const PlatformProtectedRoute: React.FC<PlatformProtectedRouteProps> = ({ 
  children, 
  feature,
  redirectTo = '/' 
}) => {
  // feature가 지정되지 않았으면 그대로 렌더링
  if (!feature) {
    return children;
  }

  // 기능이 사용 불가능하면 리다이렉트
  if (!isFeatureAvailable(feature)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default PlatformProtectedRoute;

